export enum ConfigurationUserModal {
  ADD_USER,
  MODIFY_ACCESS,
}

export enum ConfigurationServiceAccountModal {
  MODIFY_ACCESS,
  ADD_SERVICE_ACCOUNT,
}
